import { Skeleton, type Theme, styled, useTheme } from '@mui/material';
import { type SystemStyleObject } from '@mui/system';

export const SkeletonContainer = styled('div')();

export type DetailsOverviewSkeletonProps = {
  linesToClamp?: number;
  sx?: SystemStyleObject<Theme>;
};

export const DetailsOverviewSkeleton = ({ linesToClamp = 3, sx }: DetailsOverviewSkeletonProps) => {
  const theme = useTheme();

  const skeletonSx = {
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.9rem',
    },
    fontSize: '1rem',
  };

  return (
    <SkeletonContainer sx={sx}>
      {Array.from({ length: linesToClamp }).map((_, index) => (
        <Skeleton key={index} sx={skeletonSx} variant="text" />
      ))}
    </SkeletonContainer>
  );
};
